module.exports = __webpack_public_path__ + "static/media/KMH_5235.2ea826fa.jpg";